/**
 * pmsyspowerbireport.report_type – melyik TF-képernyő "BI Riport" gombja melyik riportot nyitja.
 * Új riport felvétele: sor a pmsyspowerbireport táblába a riport GUID-jával és ezzel a típuskóddal.
 */
export enum PowerBIReportType {
  CashFlow = 2,
  /** Főkönyv: kivonat ÉS karton közös riportja (ilboktmpext, head-szűrővel; cspowerbireptype 3 = "Főkönyv") */
  GeneralLedger = 3,
}

export default interface Report {
    reportId: string;
    reportName: string;
    reportType: number;
    paramId: number;
    embedUrl: string;
    /** pmsyspowerbireport.filter_panel_off = '+' → a beágyazott riport szűrőpanelje kikapcsolva */
    filterPanelOff: boolean;
    /** pmsyspowerbireport.nav_con_panel_off = '+' → a beágyazott riport lap-navigációja kikapcsolva */
    navPanelOff: boolean;
}

export const reportDefaultProps: Report = {
    reportId: "",
    reportName: "",
    reportType: 1,
    paramId: 2,
    embedUrl: "",
    filterPanelOff: false,
    navPanelOff: false,
};